<style scoped lang="scss">
    @import 'src/scss/vars';    //от папки со сборкой
    .gallery {
      --thumbBarHeight: calc(var(--sizeCell) * 7);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-flow: column nowrap;
      .main {
        flex-grow: 1;
        background-color: $clrBgDarkMore;
        position: relative;
        .slider-main {
          outline:none;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          overflow: hidden;



          .slide-main {
            width: 100%;
            /*height: calc(100vh - var(--thumbBarHeight));*/
            height: calc(var(--vh) - var(--thumbBarHeight));
          }
        }
      }
      .thumbnails {
        height: var(----thumbBarHeight);
        background-color: $clrBgDarkLess;
        .slider-thumbnails {
          outline: none;
          height: var(----thumbBarHeight);
          .slide-thumbnail {
            width: calc(var(--sizeCell) * 5);
            height: calc(var(--sizeCell) * 5);
            overflow: hidden;
            display: flex;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            transition: border $timeShort;

            border: var(--sizeCell) solid transparent;
            //фикс какой-то херни с бордюрами
            border-top: calc(var(--sizeCell) - 1px) solid transparent;
            border-bottom: calc(var(--sizeCell) - 1px) solid transparent;

            box-sizing: content-box;
            &.is-nav-selected {
              border: var(--sizeCell) solid $clrBgDarkMore !important;
              border-top: calc(var(--sizeCell) - 1px) solid $clrBgDarkMore !important;
              border-bottom: calc(var(--sizeCell) - 1px) solid $clrBgDarkMore !important;
            }
            &.hover {
              border: var(--sizeCell) solid $clrAccBg;
              border-top: calc(var(--sizeCell) - 1px) solid $clrAccBg;
              border-bottom: calc(var(--sizeCell) - 1px) solid $clrAccBg;
            }
          }
        }

      }

      //для телефонов в ландшафте
      @media (max-height: 500px) {
        /*border: 10px solid darkred;*/
        --thumbBarHeight: calc(var(--sizeCell) * 3);
        .thumbnails {
          .slider-thumbnails {
            .slide-thumbnail {
              width: calc(var(--sizeCell) * 2)!important;
              height: calc(var(--sizeCell) * 2)!important;
              border-width: calc(var(--sizeCell) * 0.5) !important;
              &.is-nav-selected {
                border-width: calc(var(--sizeCell) * 0.5) !important;
              }
            }

          }

        }
      }
    }
</style>

<template>
    <div class="modal-gallery">
      <modal-box
        :enable-always-fullscreen="true"
        ref="modalBox"
        @close="onCloseHandler"
        @keyup.ecs="test"
      >
        <div class="gallery" ref="gallery">
          <div class="main">
            <div class="slider-main"
                      v-if="Object.keys(images).length > 0"
                      ref="sliderMain"
                      :options="sliderMainOptions"
            >
              <slide-main 
                ref="slides"
                v-for="(image, index) in images"
                :image="image" :key="index"
                :gallery="$refs.gallery"
                @NeedToDisableFlickityPan="_disablePanGesture"
                @needToEnableFlickityPan="_enablePanGesture"
              >
                
              </slide-main>
            </div>
          </div>
          <div class="thumbnails">
            <div class="slider-thumbnails"
                v-if="Object.keys(images).length > 0"
                 ref="sliderThumbnails"
                :options="sliderThumbnailsOptions"
            >
              <div v-for="image in images" class="slide-thumbnail"
                   @mouseenter="makeHover"
                   @mouseleave="makeUnHover"
                   @touchstart="makeHover"
                   @touchend="makeUnHover"
              >
                <img :src="image.thumb">
              </div>
            </div>
          </div>
        </div>
      </modal-box>
    </div>
</template>

<script>
    import ModalBox from '../components/modal-box'
    import SlideMain from '../components/slide-main'

    import Flickity from 'flickity/dist/flickity.pkgd.min.js';

    export default {
      components:{
        ModalBox,
        Flickity,
        SlideMain
      },

      props: {
        isOpen: {
          type: Boolean,
          default: false
        },

        images: {
          type: Array,
          default: () => []
        }
      },
      data(){
        return {
          flktyThumbs: null,
          flktyMain: null,
          // isMounted: false,
          // эти настройки неработают, но используются. ХЗ в чем дело. Забыл уже
          sliderThumbnailsOptions: {
            prevNextButtons: false,
            pageDots: false,
            contain:true,
            freeScroll: true,   //как-то поприятнее мне с этим показалось
            wrapAround: false,  //true не канает если картинок меньше чем длина полосы
            dragThreshold: 10,
            // asNavFor: this.$refs.sliderMain,
            // asNavFor: '.slider-main',
          },
          // эти настройки неработают, но используются. ХЗ в чем дело. Забыл уже
          sliderMainOptions: {
            prevNextButtons: false,
            pageDots: false,
            contain:true,
            wrapAround: false,  //true не канает если картинок меньше чем длина полосы
            dragThreshold: 10,

          }
        }
      },
      watch: {
        isOpen(newVal){
          if (newVal) {
            this.$refs.modalBox.open()
          } else {
            this.$refs.modalBox.close()
          }
        },
        images(newVal){
          if (newVal.length > 0){
            this.$nextTick(()=>{
              this._initSliders();
            })
          }
          else {
            this._destroySliders();
          }
        }
      },
      methods: {
        test(){
          console.log('test')
        },
        _initSliders(){
          // console.log('_initSliders')
          this.flktyMain = new Flickity( this.$refs.sliderMain, {
            prevNextButtons: false,
            pageDots: false,
            contain:true,
            wrapAround: false,  //true не канает если картинок меньше чем длина полосы
            dragThreshold: 10,
            // dragThreshold: 100,
              
            // на проде должно быть lazyLoad: 1
            lazyLoad: 1,
            // lazyLoad: true,
            percentPosition: false,
            // draggable: false,
          });
          this.flktyMain.on( 'change', this._resetTransformOnAllSlides);
          
          
          this.flktyThumbs = new Flickity( this.$refs.sliderThumbnails, {
            prevNextButtons: false,
            pageDots: false,
            contain:true,
            freeScroll: true,   //как-то поприятнее мне с этим показалось
            wrapAround: false,  //true не канает если картинок меньше чем длина полосы
            dragThreshold: 10,
            asNavFor: this.$refs.sliderMain,
            percentPosition: false,
          });
        },
        _destroySliders(){

          this.flktyThumbs.destroy();
          this.flktyMain.destroy();
          // console.log('_destroySliders')
        },
        onCloseHandler(){
          this.$store.commit('setIsGalleryOpen', false)
          this.$store.commit('setGalleryItems', [])
        },
        makeHover(event){
          // console.log(event.type)
          //если тач то не реагировать на мышь
          if ('ontouchstart' in window && event.type == 'mouseenter') return;
          event.currentTarget.classList.add('hover');
        },
        makeUnHover(){
          // console.log(event.type)
          event.currentTarget.classList.remove('hover');
        },
        _disablePanGesture(){
          // console.log('_disablePanGesture')
          this.flktyMain.options.draggable = false;
          this.flktyMain.updateDraggable();
        },
        _enablePanGesture(){
          // console.log('_enablePanGesture')
          this.flktyMain.options.draggable = true;
          this.flktyMain.updateDraggable();
        },
        _resetTransformOnAllSlides(){
          this.$refs.slides.forEach(function(slide){
            slide.resetTransform();
          })
        },
      },
      mounted(){
        window.addEventListener('keyup', (event)=>{
          if (event.which == 27) {
            this.$refs.modalBox.close();
            // console.log('closed')
          }
        });
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/modal-gallery.vue